import React from 'react'
import axios from 'axios'
import apiUrl from '../../../../../apiConfig'
import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

class QuizRegistrantsModal extends React.Component {
  state = {
    selectedEmails: [],
    deleting: false
  }

  displayNames = {
    email: 'Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    high_school: 'School Name',
    company_name: 'Company Name',
    mobile_phone: 'Mobile Phone',
    birthday: 'Birth Date',
    education: 'Education Level',
    address_1: 'Address',
    address_2: 'Address Apt/Suite #',
    city: 'City',
    state: 'State',
    zip: 'Zip Code',
    contact: 'Contact',
    timestamp: 'Registered On'
  }

  componentDidUpdate (prevProps) {
    if (prevProps.registrants !== this.props.registrants) {
      this.setState({ selectedEmails: [] })
    }
  }

  toggleSelectOne = (email) => {
    const selectedEmails = this.state.selectedEmails.includes(email)
      ? this.state.selectedEmails.filter((e) => e !== email)
      : [...this.state.selectedEmails, email]
    this.setState({ selectedEmails })
  }

  toggleSelectAll = (emails) => {
    const allSelected = emails.length > 0 && emails.every((e) => this.state.selectedEmails.includes(e))
    this.setState({ selectedEmails: allSelected ? [] : emails })
  }

  handleDelete = () => {
    this.setState({ deleting: true })
    axios({
      url: apiUrl + '/delete-registrant',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.props.user.id} ${this.props.user.refresh} ${this.props.user.access}`
      },
      data: {
        email: this.state.selectedEmails,
        cognitoId: this.props.userData[0].cognitoId
      }
    })
      .then(() => {
        this.setState({ deleting: false, selectedEmails: [] })
        this.props.msgAlert({
          heading: 'Successfully Deleted Registrant(s)',
          variant: 'success'
        })
        if (this.props.refreshRegistrants) {
          this.props.refreshRegistrants()
        }
      })
      .catch((err) => {
        this.setState({ deleting: false })
        this.props.msgAlert({
          heading: 'Error',
          message: err.response.data.error,
          variant: 'danger'
        })
      })
  }

  render () {
    const registrants = this.props.registrants || []
    const columns = Object.keys(this.displayNames).filter((key) =>
      registrants.some((r) => r[key] !== null && r[key] !== undefined && r[key] !== '')
    )
    const selectableEmails = registrants.filter((r) => r.email).map((r) => r.email)
    const allSelected = selectableEmails.length > 0 && selectableEmails.every((e) => this.state.selectedEmails.includes(e))

    return (
      <Modal show={this.props.show} onHide={this.props.onHide} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>Quiz Registrants{this.props.quizTitle ? `: ${this.props.quizTitle}` : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.loading &&
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' role='status' />
            </div>
          }
          {!this.props.loading && registrants.length === 0 &&
            <div>No registrants found for this quiz.</div>
          }
          {!this.props.loading && registrants.length > 0 &&
            <React.Fragment>
              <div className='d-flex justify-content-between align-items-center mb-2'>
                <Form.Check
                  label='Select All'
                  checked={allSelected}
                  onChange={() => this.toggleSelectAll(selectableEmails)}
                />
                <Button
                  variant='danger'
                  disabled={this.state.selectedEmails.length === 0 || this.state.deleting}
                  onClick={this.handleDelete}
                >
                  {this.state.deleting
                    ? <React.Fragment><Spinner as='span' animation='grow' size='sm' role='status' />&nbsp;Deleting...</React.Fragment>
                    : `Delete Selected (${this.state.selectedEmails.length})`
                  }
                </Button>
              </div>
              <div style={{ overflowX: 'auto' }}>
                <Table striped bordered hover size='sm'>
                  <thead>
                    <tr>
                      <th></th>
                      <th>#</th>
                      {columns.map((key) => (
                        <th key={key}>{this.displayNames[key]}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {registrants.map((r, i) => (
                      <tr key={i}>
                        <td>
                          <Form.Check
                            disabled={!r.email}
                            checked={!!r.email && this.state.selectedEmails.includes(r.email)}
                            onChange={() => this.toggleSelectOne(r.email)}
                          />
                        </td>
                        <td>{i + 1}</td>
                        {columns.map((key) => (
                          <td key={key}>{r[key]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </React.Fragment>
          }
        </Modal.Body>
      </Modal>
    )
  }
}

export default QuizRegistrantsModal
